// extracted by mini-css-extract-plugin
export default {"menuIcon":"businessUnit_menuIcon__PfN7Q"};